import { useEffect } from 'react';

export const useOnClickOutside = ({ ref, handler }) => {
  useEffect(() => {
    const eventListenerHandler = event => {
      const { target } = event;
      if (ref.current && !ref.current.contains(target)) {
        handler(event);
      }
    };

    document.addEventListener('click', eventListenerHandler, true);
    return () => {
      document.removeEventListener('click', eventListenerHandler, true);
    };
  }, [ref, handler]);
};
